export type CreativeCategory =
  | 'all'
  | 'cover-design'
  | 'interior-art'
  | 'character-art'
  | 'merch'
  | 'photography'
  | 'models'

export interface CreativeProfessional {
  id: string
  name: string
  title: string
  category: Exclude<CreativeCategory, 'all'>
  specialties: string[]
  rating: number
  reviewCount: number
  image: string
  available: boolean
}

/** Creative professionals shown in the directory and on profile pages. */
export const creativeProfessionals: CreativeProfessional[] = [
  {
    id: 'cd1',
    name: 'Alex Morgan',
    title: 'Cover Designer',
    category: 'cover-design',
    specialties: ['Fantasy', 'YA', 'Illustrated Covers'],
    rating: 4.9,
    reviewCount: 127,
    image:
      'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
    available: true,
  },
  {
    id: 'cd2',
    name: 'Jordan Lee',
    title: 'Book Cover Artist',
    category: 'cover-design',
    specialties: ['Romance', 'Contemporary', 'Typography'],
    rating: 4.7,
    reviewCount: 93,
    image:
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
    available: true,
  },
  {
    id: 'ia1',
    name: 'Riley Zhang',
    title: 'Interior Book Artist',
    category: 'interior-art',
    specialties: ['Chapter Headers', 'Decorative Elements', 'Maps'],
    rating: 4.8,
    reviewCount: 84,
    image:
      'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
    available: false,
  },
  {
    id: 'ia2',
    name: 'Taylor Kim',
    title: 'Interior Layout Designer',
    category: 'interior-art',
    specialties: ['Typography', 'Page Design', 'Endpapers'],
    rating: 4.6,
    reviewCount: 56,
    image:
      'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
    available: true,
  },
  {
    id: 'ca1',
    name: 'Morgan Rivera',
    title: 'Character Artist',
    category: 'character-art',
    specialties: ['Fantasy Characters', 'Portraits', 'Digital Art'],
    rating: 5.0,
    reviewCount: 142,
    image:
      'https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
    available: true,
  },
  {
    id: 'ca2',
    name: 'Casey Wilson',
    title: 'Character Illustrator',
    category: 'character-art',
    specialties: ['Sci-Fi', 'Comic Style', 'Concept Art'],
    rating: 4.8,
    reviewCount: 78,
    image:
      'https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
    available: true,
  },
  {
    id: 'md1',
    name: 'Jamie Patel',
    title: 'Merchandise Designer',
    category: 'merch',
    specialties: ['Apparel', 'Accessories', 'Branding'],
    rating: 4.7,
    reviewCount: 63,
    image:
      'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
    available: true,
  },
  {
    id: 'md2',
    name: 'Quinn Smith',
    title: 'Book Merchandise Specialist',
    category: 'merch',
    specialties: ['Bookmarks', 'Candles', 'Gift Boxes'],
    rating: 4.5,
    reviewCount: 47,
    image:
      'https://images.unsplash.com/photo-1552058544-f2b08422138a?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
    available: false,
  },
  {
    id: 'pg1',
    name: 'Avery Johnson',
    title: 'Author Photographer',
    category: 'photography',
    specialties: ['Portraits', 'Book Events', 'Marketing Photos'],
    rating: 4.9,
    reviewCount: 115,
    image:
      'https://images.unsplash.com/photo-1504257432389-52343af06ae3?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
    available: true,
  },
  {
    id: 'pg2',
    name: 'Skyler Thomas',
    title: 'Book Cover Photographer',
    category: 'photography',
    specialties: ['Product Photography', 'Landscapes', 'Conceptual'],
    rating: 4.6,
    reviewCount: 82,
    image:
      'https://images.unsplash.com/photo-1542909168-82c3e7fdca5c?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
    available: true,
  },
  {
    id: 'mo1',
    name: 'Jordan Ellis',
    title: 'Book Cover Model',
    category: 'models',
    specialties: ['Romance', 'Historical', 'Contemporary'],
    rating: 4.8,
    reviewCount: 74,
    image:
      'https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
    available: true,
  },
  {
    id: 'mo2',
    name: 'Harper Davis',
    title: 'Character Model',
    category: 'models',
    specialties: ['Fantasy', 'Period Costumes', 'Action'],
    rating: 4.7,
    reviewCount: 59,
    image:
      'https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
    available: false,
  },
]

export const getCreativeById = (id: string | undefined) =>
  creativeProfessionals.find((creative) => creative.id === id)
